import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalAulasCanceladas(props) {
    const { estrutura } = props;
    const { alunos } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "alunos",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Aluno',
                    accessor: 'matricula'
                },
                {
                    Header: 'Nome',
                    accessor: 'nome_aluno',
                },
                {
                    Header: 'CPF',
                    accessor: 'cpf_aluno',
                },
                {
                    Header: 'Grupo',
                    accessor: 'grupo',
                },
                {
                    Header: 'Serviço',
                    accessor: 'servico',
                },
                {
                    Header: 'Local',
                    accessor: 'local',
                },
                {
                    Header: 'Data',
                    accessor: 'data_ptbr',
                },
                {
                    Header: 'Hora Início',
                    accessor: 'hora_inicio',
                },
                {
                    Header: 'Intervalo Início',
                    accessor: 'intervalo_inicio',
                },
                {
                    Header: 'Intervalo Fim',
                    accessor: 'intervalo_fim',
                },
                {
                    Header: 'Fim',
                    accessor: 'fim',
                },
                {
                    Header: 'Professor',
                    accessor: 'professor',
                },
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={alunos}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalAulasCanceladas;
